export function remap(
    value: number,
    lowIn: number,
    highIn: number,
    lowOut: number,
    highOut: number,
) {
    return lowOut + ((highOut - lowOut) * (value - lowIn)) / (highIn - lowIn);
}
